export const userPlans = [
	{
		id: 'Subscribe-Yearly',
		title: 'Yearly Plan',
		cbItem: 'on-demand-individual-yearly',
		price: 149.99,
		save: 37,
		days: 7,
		param: 'yearly'
	},
	{
		id: 'Subscribe-Monthly',
		title: 'Monthly Plan',
		cbItem: 'individual-monthly',
		price: 19.99,
		save: 0,
		days: 3,
		param: 'monthly'
	}
];

export const studioPlans = [
	{
		id: 'Studio-Account-5',
		title: 'Studio Plan - 5',
		seats: 5,
		cbItem: 'Studio-Account-5-USD-Yearly',
		days: 0,
		param: 'yearly'
	},
	{
		id: 'Studio-Account-10',
		title: 'Studio Plan - 10',
		seats: 10,
		cbItem: 'Studio-Account-10-Seats-USD',
		days: 0,
		param: 'yearly'
	}
];

export const userVIPPlans = [
	{
		id: 'VIP-Yearly',
		title: 'Yearly Plan',
		cbItem: 'On-Demand-Plus-USD-Yearly',
		price: 249.99,
		save: 40,
		days: 7,
		param: 'yearly'
	},
	{
		id: 'VIP-Monthly',
		title: 'Monthly Plan',
		cbItem: 'On-Demand-Plus-USD-Monthly',
		price: 34.99,
		save: 0,
		days: 3,
		param: 'monthly'
	}
];
